﻿import RMSInstructionTypePage from "./rmsInstructionTypePage";
import RMSReminderSetupPage from "./rmsReminderSetupPage";
import RMSRemindersPage from "./rmsRemindersPage";
import RMSPortfolioReviewPage from "./rmsPortfolioReviewPage";
import RMSInstructionsPage from "./rmsInstructionsPage";
import RMSActionClosePage from "./rmsActionClosePage";
import RMSActionCloseLogPage from "./rmsActionCloseLogPage";


if (!window.rmsInstructionTypePage) {
    window.rmsInstructionTypePage = new RMSInstructionTypePage();
}

if (!window.rmsReminderSetupPage) {
    window.rmsReminderSetupPage = new RMSReminderSetupPage();
}

if (!window.rmsRemindersPage) {
    window.rmsRemindersPage = new RMSRemindersPage();
}

if (!window.rmsPortfolioReviewPage) {
    window.rmsPortfolioReviewPage = new RMSPortfolioReviewPage();
}

if (!window.rmsInstructionsPage) {
    window.rmsInstructionsPage = new RMSInstructionsPage();
}

if (!window.rmsActionClosePage) {
    window.rmsActionClosePage = new RMSActionClosePage();
}

if (!window.rmsActionCloseLogPage) {
    window.rmsActionCloseLogPage = new RMSActionCloseLogPage();
}


